
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/partner-intake/social-ai",
      function () {
        return require("private-next-pages/partner-intake/social-ai/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/partner-intake/social-ai"])
      });
    }
  